module.exports = __webpack_public_path__ + "img/icon_menu_bottom.98e0765a.png";